export default "__VITE_ASSET__BYhcCpW4__"